/**
 * Uso da area (spec 062, fase 2): um sinal por minuto pro backend, so com a aba visivel e com algum movimento (toque,
 * tecla, rolagem, mouse) nos ultimos 5 minutos. Aba esquecida aberta nao conta. A sessao assistida nao manda nada.
 * `tela` e o primeiro pedaco do endereco ("inicio" na raiz). Erro nunca aparece pra pessoa.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { useSessao } from "./sessao";

const MINUTO = 60_000;
const PARADO_DEMAIS = 5 * MINUTO;

export function telaDoEndereco(caminho: string): string {
  const primeiro = caminho.split("/").filter(Boolean)[0]?.toLowerCase() ?? "";
  return /^[a-z0-9-]{1,40}$/.test(primeiro) ? primeiro : "inicio";
}

export function useSinalDeUso(ligado: boolean) {
  const { api } = useSessao();
  const local = useLocation();
  const tela = useRef("inicio");
  tela.current = telaDoEndereco(local.pathname);
  useEffect(() => {
    if (!ligado) return;
    let mexeu = Date.now();
    const movimento = () => { mexeu = Date.now(); };
    const eventos = ["pointerdown", "pointermove", "keydown", "scroll", "touchstart"] as const;
    for (const e of eventos) window.addEventListener(e, movimento, { passive: true });
    const vez = window.setInterval(() => {
      if (document.visibilityState !== "visible" || Date.now() - mexeu > PARADO_DEMAIS) return;
      void api("/v1/me/uso", { method: "POST", body: JSON.stringify({ tela: tela.current }) }).catch(() => undefined);
    }, MINUTO);
    return () => {
      window.clearInterval(vez);
      for (const e of eventos) window.removeEventListener(e, movimento);
    };
  }, [ligado, api]);
}
